import { render, staticRenderFns } from "./ClientCannotAccess.vue?vue&type=template&id=5149e9d1&"
import script from "./ClientCannotAccess.vue?vue&type=script&lang=js&"
export * from "./ClientCannotAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports